import type { FaireProductEntity } from "../../entity_types/product";

export const p_7morks3735: FaireProductEntity = {
  token: "p_7morks3735",
  type: "product",
  name: "Pretty Leaves Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/7d084393ac75c3c02b06ef750fb0e27f01f7a536e9de1d447b5f922e3011e073.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/29fbe3ed50f219bd0cf2cae568484228f0ca12aaed62b42a2556ccd315019c78.png",
    "https://cdn.faire.com/fastly/372273c8c76e4d609bd66e7ae17129709d824886cb5efc3bae1ba73b8459b738.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:44.567Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
